import { AController } from "@eagerlogic/react-mvc";
import { MeetTheTeamModel, TeamModel, TeamMemberModel } from "../model/MeetTheTeamModel";
import { TeamListItem, TeamRpc } from "rpc/TeamRpc";
import { UsersRpc, UserListItem } from "rpc/UsersRpc";

export class MeetTheTeamController extends AController<MeetTheTeamModel> {

    private teamsDto: TeamListItem[] = [];
    private usersDto: UserListItem[] = [];

    protected createInitialModel(): MeetTheTeamModel {
        var res = new MeetTheTeamModel();

        this.loadData();

        return res;
    }

    public onSearchTermChanged(st: string) {
        this.model.searchTerm = st;
        this.refresh();
    }

    private loadData() {
        var tp = TeamRpc.list();
        var up = UsersRpc.list();

        Promise.all([tp, up])
        .then((dtos) => {
            this.teamsDto = dtos[0].teams;
            this.usersDto = dtos[1].users;
            this.refresh();
        })
    }

    private refresh() {
        var st = this.model.searchTerm;
        if (st == null) {
            st = "";
        }

        var sts: string[] = [];
        if (st.length > 0) {
            sts = st.split(" ");
        }

        var res = new MeetTheTeamModel();
        res.searchTerm = st;
        for (var teamDto of this.teamsDto) {
            var teamModel = new TeamModel();
            teamModel.id = teamDto.id;
            teamModel.name = teamDto.name;
            teamModel.members = [];
            res.teams.push(teamModel);
        }
        var noTeamModel = new TeamModel();
        noTeamModel.id = null;
        noTeamModel.name = "No Team";
        noTeamModel.members = [];
        res.teams.push(noTeamModel);

        for (var userDto of this.usersDto) {
            if (!this.isMatch(userDto, sts)) {
                continue;
            }
            var userModel = new TeamMemberModel();
            userModel.address = userDto.address;
            userModel.bio = userDto.bio;
            userModel.chat = userDto.chatAddress;
            userModel.email = userDto.email;
            userModel.id = userDto.id;
            userModel.memberSince = userDto.memberSince;
            userModel.name = userDto.visibleName;
            userModel.phonePrivate = userDto.homePhone;
            userModel.phoneWork = userDto.workPhone;
            userModel.position = userDto.position;
            userModel.teamId = userDto.teamId;

            for (var tm of res.teams) {
                if (tm.id == userModel.teamId) {
                    tm.members.push(userModel);
                }
            }
        }

        this.render(res);
    }

    private isMatch(userDto: UserListItem, sts: string[]): boolean {
        for (var st of sts) {
            st = st.toLowerCase();
            if (st.length < 1) {
                continue;
            }

            if (userDto.visibleName.toLowerCase().indexOf(st) < 0) {
                return false;
            }
        }

        return true;
    }


    
}